/** Cross-UI signal that wallet balance may have changed after AI usage. */
export const BILLING_BALANCE_CHANGED_EVENT = 'billing:balance-changed';

export function notifyBillingBalanceChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(BILLING_BALANCE_CHANGED_EVENT));
}
